import { isPortrait } from './utils';

document.addEventListener('DOMContentLoaded', function (event) {
  setTimeout(() => {
    document.querySelectorAll('.js-rotate-90').forEach((child) => {
      var height = Math.ceil(child.getBoundingClientRect().height || 0);
      var width = Math.ceil(child.getBoundingClientRect().width || 0);
      var parent = child.parentElement;
      child.style.top = height + 'px';
      //   parent.style.width = width + 'px';
      parent.style.height = height + 'px';
    });
  }, 2500);
});

const setOrientation = () => {
  document.querySelectorAll('.js-orientation').forEach((element) => {
    element.classList.add(isPortrait(element) ? 'portrait' : 'landscape');
  });
};

window.addEventListener('load', setOrientation);

document.querySelectorAll('.js-click-toggle').forEach((toggle) => {
  var handler = toggle.querySelector('.js-click-toggle-handler');
  var element = toggle.querySelector('.js-click-toggle-element');
  if (handler && element) {
    element.classList.add('hidden');
    toggle.classList.add('closed');
    handler.addEventListener('click', () => {
      toggle.classList.toggle('closed');
      toggle.classList.toggle('open');
      element.classList.toggle('hidden');
    });
  }
});

document.querySelectorAll('.js-hover-show').forEach((show) => {
  var hideTimeout = null;
  show.addEventListener('mouseenter', (e) => {
    show.parentNode.querySelectorAll('.js-hover-show .js-hover-show-element').forEach((element) => {
      element.classList.add('hidden');
    });

    if (hideTimeout) clearTimeout(hideTimeout);
    var element = show.querySelector('.js-hover-show-element');
    if (element) {
      element.classList.remove('hidden');
      show.classList.add('open');
      show.classList.remove('closed');
    }
  });
  show.addEventListener('mouseleave', (e) => {
    var element = show.querySelector('.js-hover-show-element');
    if (element) {
      hideTimeout = setTimeout(() => {
        element.classList.add('hidden');
        show.classList.remove('open');
        show.classList.add('closed');
      }, 250);
    }
  });
});
// document.querySelectorAll('.js-total-child-width').forEach((parent) => {
//   var totalWidth = 0;
//   for (var i = 0; i < parent.children.length; i++) {
//     console.log(totalWidth);
//     totalWidth += parseInt(parent.children[i].offsetWidth, 10);
//   }
//   parent.style.width = totalWidth + 'px';
// });
